module.exports = __webpack_public_path__ + "fonts/dccb10af-07a2-404c-bfc7-7750e2716bc1.17aac52.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/dccb10af-07a2-404c-bfc7-7750e2716bc1.eot
// module id = 86
// module chunks = 245 246